// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__SmopK","contactsWrapper":"Contacts_contactsWrapper__knl-e","contactsInner":"Contacts_contactsInner__MMxRL","animation":"Contacts_animation__OXz4t"};